import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ progress, status, currentStep, steps = [] }) => {
  const getStatusColor = () => {
    if (status === 'rejected') return '#ef4444';
    if (status === 'approved') return '#10b981';
    return '#f59e0b'; // pending
  };

  const getStepName = (step) => {
    const stepNames = {
      1: 'Finance Director',
      2: 'Company MD',
      3: 'Company Chairman',
      4: 'Iconic Unity MD',
      5: 'Iconic Unity Chairman',
    };
    return stepNames[step] || `Step ${step}`;
  };

  return (
    <div className="progress-bar-container">
      <div className="progress-bar-header">
        <span className="progress-label">Progress: {progress}%</span>
        {status === 'pending' && currentStep && (
          <span className="current-step-label">
            Current: {getStepName(currentStep)}
          </span>
        )}
      </div>
      
      <div className="progress-bar-wrapper">
        <div 
          className="progress-bar-fill"
          style={{ 
            width: `${progress}%`,
            backgroundColor: getStatusColor()
          }}
        />
      </div>

      {steps.length > 0 && (
        <div className="progress-steps">
          {steps.map((step, index) => (
            <div 
              key={index}
              className={`progress-step ${step.completed ? 'completed' : ''} ${step.current ? 'current' : ''} ${step.rejected ? 'rejected' : ''}`}
            >
              <div className="step-indicator">
                {step.rejected ? '✕' : step.completed ? '✓' : index + 1}
              </div>
              <div className="step-name">{step.name}</div>
            </div>
          ))}
        </div>
      )}

      <div className="progress-status">
        <span className={`status-badge status-${status}`}>
          {status === 'pending' ? 'Pending' : status === 'approved' ? 'Approved' : 'Rejected'}
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
